import React from "react";
import { Grid, Paper, Typography, Stack, Box } from "@mui/material";
import Datasheet from "./olexhvdatasheet.json"

function Datasheetcomponent({inputData }) {

const conductor = inputData.conductor;
const voltagelabel = inputData.voltagelabel;
const cabletype = inputData.cabletype;
const datasheet = Datasheet[conductor]?.[cabletype]?.[voltagelabel];
    
        return (
        <div className="App">

      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems=""
        style={{ minHeight: "10vh", paddingTop: "1rem" }}
      >

                <Grid item xs={11} sm={11} md={12}>
                  <Paper
                    elevation={6}
                    style={{
                      padding: "2.5rem",
                      
                      borderRadius: "20px",
                      background: "#ffffff",
                      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                      <Typography variant="h5"          
                       sx={{
                        fontSize: { xs: "16px", md: "20px" }, // Adjust font size for subtitle
                        fontWeight: "700",
                        fontFamily: "'Hubballi', sans-serif",
                        letterSpacing: "1px",
                    }}> 
                        CABLE DATASHEET
                      </Typography>
                    </Stack>
        
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <img
          src={datasheet}
          width="60%"
          height="60%"
          style={{ objectFit: "contain", borderRadius: "4px" }}
        />
      </Box>
                            
                  </Paper>
                </Grid>






      </Grid>






        </div>


              );
}

export default Datasheetcomponent;